import { render, staticRenderFns } from "./StatisticsReferrals.vue?vue&type=template&id=e177b6f2&scoped=true&"
import script from "./StatisticsReferrals.vue?vue&type=script&lang=js&"
export * from "./StatisticsReferrals.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsReferrals.vue?vue&type=style&index=0&id=e177b6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e177b6f2",
  null
  
)

export default component.exports